export default "__VITE_ASSET__CYAwlfy1__"